import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

import type { Period } from "@/components/PeriodTabs";
import { presetRange, type DateRange } from '@/lib/dateRange';

interface PeriodContextValue {
  period: Period;
  setPeriod: (period: Period) => void;
  dateRange?: DateRange;
  setDateRange: (range: DateRange) => void;
}

const PeriodContext = createContext<PeriodContextValue | undefined>(undefined);

/**
 * Donem sekmesi (7/30/90 gun) tum tenant_user govdesinde PAYLAŞILIR — ust
 * barda secilir (Layout), /ozet ve /kpi (P5-F2) ayni degeri okur. Sozlesme:
 * "üst bar: tenant adı+logo+dönem seçici".
 */
export function PeriodProvider({ children, defaultPeriod = 7 }: { children: ReactNode; defaultPeriod?: Period }) {
  const [period, setPeriodState] = useState<Period>(defaultPeriod);
  const [dateRange, setDateRange] = useState<DateRange>();
  const value = useMemo<PeriodContextValue>(() => ({ period, dateRange, setDateRange,
    setPeriod: (next) => { setPeriodState(next); setDateRange(presetRange(String(next) as '7' | '30' | '90')); },
  }), [period, dateRange]);
  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
}

export function usePeriod(): PeriodContextValue {
  const ctx = useContext(PeriodContext);
  if (!ctx) throw new Error("usePeriod() yalnizca <PeriodProvider> icinde kullanilabilir");
  return ctx;
}
